import { db } from "@/db/db";
import { workspaceMembership } from "@/db/schema";
import { bulkUpsertTag } from "@/models/repositories/Tag";
import { bulkUpsertWorkspaceMembershipTag } from "@/models/repositories/WorkspaceMembershipTag";

const FAKE_TAGS = [
  { id: "tag-driver-type", label: "Driver Type", enabled: true, multiValue: false },
  { id: "tag-terminal-name", label: "Terminal Name", enabled: true, multiValue: false },
  { id: "tag-terminal-location", label: "Terminal Location", enabled: true, multiValue: false },
  { id: "tag-certifications", label: "Certifications", enabled: true, multiValue: true },
];

const DRIVER_TYPES = ["Company", "Company Driver", "Exempt", "Leased Op Driver", "Leased Operator", "Training"];

const CERTIFICATIONS = ["HazMat", "Tanker", "TWIC", "Doubles/Triples", "Passenger", "School Bus"];

interface Terminal {
  name: string;
  location: string;
}

const TERMINALS: Terminal[] = [
  { name: "A00010", location: "Rapid City, SD" },
  { name: "A00050", location: "Marshall, TX" },
  { name: "A00130", location: "San Antonio, TX (Dry Bulk)" },
  { name: "A00220", location: "Calvert City, KY" },
  { name: "A00240", location: "Louisville, KY" },
  { name: "A00270", location: "Chicago, IL" },
  { name: "A00310", location: "Brownsville, TX" },
  { name: "A00340", location: "Brownsville, TX" },
  { name: "A00400", location: "Portland, OR" },
  { name: "A00420", location: "Downey, CA" },
  { name: "A00460", location: "Downey, CA" },
  { name: "A00480", location: "Hesperia, CA" },
  { name: "A02020", location: "Atlanta, GA" },
  { name: "A02050", location: "Portage, IN" },
  { name: "A03070", location: "Bayport, TX" },
  { name: "A03110", location: "Memphis, TN" },
  { name: "A03210", location: "Beaumont, TX" },
  { name: "A03230", location: "Geismar, LA" },
  { name: "A03390", location: "Detroit, MI" },
  { name: "A03450", location: "Fairburn, GA" },
  { name: "A03480", location: "Spartanburg, SC" },
  { name: "A03640", location: "Rock Springs, WY" },
  { name: "A03650", location: "Pensacola, FL" },
  { name: "A05120", location: "Wink, TX (Crude)" },
  { name: "A05200", location: "STC - Mobile, AL" },
  { name: "A05210", location: "STC - Jacksonville, FL" },
  { name: "A05220", location: "STC - Tampa, FL" },
  { name: "A05230", location: "STC - Augusta, GA" },
  { name: "A05240", location: "STC - Joliet, IL" },
  { name: "A05250", location: "STC - East St Louis, IL" },
  { name: "A05260", location: "STC - St Gabriel, LA" },
  { name: "A05270", location: "STC - Sterlington, LA" },
  { name: "A05280", location: "STC - Charlotte, NC" },
  { name: "A05290", location: "STC - Cincinnati, OH" },
  { name: "A05300", location: "STC - Memphis, TN" },
  { name: "A05310", location: "STC - Beaumont, TX" },
  { name: "A05320", location: "STC - Corpus Christi, TX" },
  { name: "A05330", location: "STC - Freeport, TX" },
  { name: "A05340", location: "STC - Houston, TX" },
  { name: "A05350", location: "STC - Nitro, WV" },
  { name: "A05520", location: "Feldspar, NC" },
  { name: "A05530", location: "Victorville, CA" },
  { name: "A05540", location: "El Mirage, AZ" },
  { name: "A08340", location: "Greeley, CO (Crude)" },
  { name: "A08410", location: "Bristol, PA" },
  { name: "C00030", location: "Ashcroft, BC" },
  { name: "C00050", location: "Kamloops Fuel" },
  { name: "C00060", location: "Richmond, BC" },
  { name: "C00070", location: "Langley, BC" },
  { name: "C00080", location: "Mississauga, ON" },
  { name: "C00140", location: "Dawson Creek, BC" },
  { name: "C00170", location: "Edmonton, AB" },
  { name: "C00200", location: "Fort Saskatchewan, AB" },
  { name: "C00240", location: "Winnipeg, MB" },
  { name: "C00250", location: "Sarnia, ON" },
  { name: "C00280", location: "St. George, ON" },
  { name: "C00310", location: "Bronte, ON" },
  { name: "C00410", location: "Thorold, ON" },
  { name: "C00460", location: "Pointe Claire, QC" },
  { name: "C00470", location: "Trail, BC" },
  { name: "C00510", location: "Concord, ON" },
  { name: "C00520", location: "Pt. Colborne, ON" },
  { name: "C00570", location: "Anjou, QC" },
  { name: "C00720", location: "Edmonton, AB" },
  { name: "C00730", location: "Hinton, AB" },
  { name: "C00780", location: "Golden, BC" },
  { name: "C00920", location: "Valleyfield, QC" },
  { name: "C00960", location: "Edmonton, AB" },
  { name: "C01340", location: "Saskatoon, SK" },
  { name: "C01350", location: "Saskatoon, SK" },
  { name: "C01620", location: "Concord, ON" },
  { name: "C01670", location: "Langley, BC" },
  { name: "C02030", location: "Mount Pearl, NL" },
  { name: "C02520", location: "Sarnia, ON" },
  { name: "C02530", location: "Levis, QC" },
  { name: "C02570", location: "Dundas, ON" },
  { name: "C02630", location: "Regina, SK" },
  { name: "C02690", location: "Pointe Claire, QC" },
  { name: "C02700", location: "Winnipeg, MB" },
  { name: "C02710", location: "Mississauga, ON (Intermodal)" },
  { name: "C02840", location: "Calgary, AB" },
  { name: "C02900", location: "Nanaimo, BC" },
  { name: "C02910", location: "Kamloops, BC" },
  { name: "C02930", location: "Prince George, BC" },
  { name: "C02950", location: "Trail, BC" },
  { name: "C03170", location: "Canamera, AB" },
  { name: "C03240", location: "Calgary, AB" },
  { name: "C03250", location: "Surrey, BC" },
  { name: "C03320", location: "Fort McMurray, AB" },
  { name: "C03330", location: "Fort McMurray, AB - Dry Bulk" },
  { name: "C03340", location: "Guelph, ON" },
  { name: "C03350", location: "Mississauga, ON" },
  { name: "C03360", location: "Mississauga, ON" },
  { name: "C03410", location: "Mount Pearl, NL" },
  { name: "C03430", location: "Prince George, BC" },
  { name: "C03460", location: "Sherwood Park, AB" },
];

function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function pickRandomSubset<T>(arr: T[], min: number, max: number): T[] {
  const count = min + Math.floor(Math.random() * (max - min + 1));
  const shuffled = [...arr].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

export async function seedDebugTags() {
  await bulkUpsertTag(FAKE_TAGS);

  const memberships = await db.select({ id: workspaceMembership.id }).from(workspaceMembership).execute();

  const assignments: { workspaceMembershipId: string; tagId: string; tagValue: string; enabled: boolean }[] = [];
  for (const membership of memberships) {
    const terminal = pickRandom(TERMINALS);
    assignments.push(
      {
        workspaceMembershipId: membership.id,
        tagId: "tag-driver-type",
        tagValue: pickRandom(DRIVER_TYPES),
        enabled: true,
      },
      { workspaceMembershipId: membership.id, tagId: "tag-terminal-name", tagValue: terminal.name, enabled: true },
      {
        workspaceMembershipId: membership.id,
        tagId: "tag-terminal-location",
        tagValue: terminal.location,
        enabled: true,
      },
      ...pickRandomSubset(CERTIFICATIONS, 1, 3).map((cert) => ({
        workspaceMembershipId: membership.id,
        tagId: "tag-certifications",
        tagValue: cert,
        enabled: true as const,
      })),
    );
  }

  await bulkUpsertWorkspaceMembershipTag(assignments);
}
